/**
 * Автоматическое добавление крафтового пакета в корзину
 */
class AutoAddBag {
  constructor() {
    this.bagVariantId = 51218624217371;
    this.bagPrice = 2500;
    this.isProcessing = false;
    this.debounceTimer = null;
    this.init();
  }

  init() {
    console.log('🛍️ Auto-add bag initialized, variant ID:', this.bagVariantId);

    // Проверяем и добавляем пакет при загрузке
    this.checkAndAddBag();

    // Слушаем обновления корзины с debounce
    document.addEventListener('cart:updated', () => {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => this.checkAndAddBag(), 800);
    });
  }

  async checkAndAddBag() {
    if (this.isProcessing) {
      console.log('🛍️ Already processing, skipping...');
      return;
    }
    
    this.isProcessing = true;

    try {
      const cart = await this.getCart();
      
      // Проверяем есть ли обычные товары (не подарки, не пакет)
      const regularItems = cart.items.filter(item => {
        const isGift = item.properties && item.properties._gift_item === 'true';
        const isBag = item.id == this.bagVariantId;
        return !isGift && !isBag;
      });

      // Считаем сколько нужно пакетов (по 1 на весь заказ)
      const neededBags = regularItems.length > 0 ? 1 : 0;

      // Проверяем сколько уже есть пакетов
      const bagItem = cart.items.find(item => item.id == this.bagVariantId);
      const currentBags = bagItem ? bagItem.quantity : 0;

      console.log(`🛍️ Analysis:`, {
        regularItems: regularItems.length,
        totalQty: regularItems.reduce((sum, item) => sum + item.quantity, 0),
        neededBags,
        currentBags
      });

      if (neededBags === 0 && currentBags > 0) {
        // Нет обычных товаров - удаляем пакет
        console.log('🗑️ Removing bag from cart');
        await this.removeBag(bagItem.key);
      } else if (neededBags > 0 && currentBags === 0) {
        // Нужен пакет, но его нет - добавляем
        console.log('➕ Adding bag to cart');
        await this.addBag(neededBags);
      } else if (neededBags > 0 && currentBags !== neededBags) {
        // Пакет есть, но количество не то - обновляем
        console.log('🔄 Updating bag quantity');
        await this.updateBag(bagItem.key, neededBags);
      } else {
        console.log('✅ Bag quantity is correct');
      }
    } catch (error) {
      console.error('❌ Error checking bag:', error);
    } finally {
      // Даем время на завершение операции
      setTimeout(() => {
        this.isProcessing = false;
      }, 500);
    }
  }

  async getCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Failed to fetch cart');
    return response.json();
  }

  /**
   * Добавить пакет в корзину
   */
  async addBag(quantity) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: this.bagVariantId,
            quantity: quantity,
            properties: {
              '_bag_item': 'true',
              '_auto_added': 'true'
            }
          }]
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'Failed to add bag');
      }

      const result = await response.json();
      console.log('✅ Bag added successfully:', result);
      
      // Обновляем UI корзины
      await this.refreshCart();
      
      return result;
    } catch (error) {
      console.error('❌ Error adding bag:', error);
      throw error;
    }
  }

  /**
   * Обновить количество пакета
   */
  async updateBag(lineItemKey, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: lineItemKey,
          quantity: quantity,
          properties: {
            '_bag_item': 'true',
            '_auto_added': 'true'
          }
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'Failed to update bag');
      }

      const cart = await response.json();
      console.log('✅ Bag updated successfully');
      
      // Обновляем UI корзины
      await this.refreshCart();
      
      return cart;
    } catch (error) {
      console.error('❌ Error updating bag:', error);
      throw error;
    }
  }

  /**
   * Удалить пакет из корзины
   */
  async removeBag(lineItemKey) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: lineItemKey,
          quantity: 0
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'Failed to remove bag');
      }

      const cart = await response.json();
      console.log('✅ Bag removed successfully');
      
      // Обновляем UI корзины
      await this.refreshCart();
      
      return cart;
    } catch (error) {
      console.error('❌ Error removing bag:', error);
      throw error;
    }
  }

  /**
   * Обновить UI корзины без перезагрузки страницы
   */
  async refreshCart() {
    try {
      const cart = await this.getCart();
      
      // Публикуем событие для обновления UI
      document.dispatchEvent(new CustomEvent('cart:refresh', { 
        detail: { cart } 
      }));

      // Обновляем счетчик корзины
      const cartCount = document.querySelectorAll('[data-cart-count], .cart-count');
      cartCount.forEach(el => {
        el.textContent = cart.item_count;
        if (cart.item_count === 0) {
          el.setAttribute('hidden', '');
        } else {
          el.removeAttribute('hidden');
        }
      });

      // Если на странице корзины - перезагружаем
      if (window.location.pathname === '/cart') {
        // Небольшая задержка чтобы избежать race conditions
        setTimeout(() => {
          window.location.reload();
        }, 300);
      }

      return cart;
    } catch (error) {
      console.error('❌ Error refreshing cart:', error);
    }
  }
}

// Инициализация
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new AutoAddBag();
  });
} else {
  new AutoAddBag();
}